<template>
  <div class="login-2fa bg-light-bg dark:bg-dark-bg text-light-text dark:text-dark-text min-h-screen flex items-center justify-center p-4">
    <div class="w-full max-w-md bg-white dark:bg-dark-box-bg shadow-custom-light dark:shadow-custom-dark rounded-lg p-6">
      <h2 class="text-xl font-bold mb-4 text-center">Two-Factor Authentication</h2>
      <p class="mb-6 text-center text-gray-600 dark:text-gray-400">
        Please enter the 2FA code sent to your email.
      </p>
      <form @submit.prevent="verify2fa">
        <div class="form-group mb-4">
          <label for="code" class="block text-sm font-medium mb-1 text-light-text dark:text-dark-text">2FA Code</label>
          <input
              type="text"
              v-model="twoFactorCode"
              id="code"
              required
              class="w-full px-4 py-2 rounded-lg bg-light-bg dark:bg-dark-row-odd border border-light-border dark:border-dark-border text-light-text dark:text-dark-text focus:outline-none focus:ring focus:ring-blue-500"
          />
        </div>
        <button
            type="submit"
            class="w-full py-2 bg-button-bg dark:bg-dark-button-bg text-button-text rounded-lg hover:bg-button-hover dark:hover:bg-dark-button-hover focus:outline-none focus:ring focus:ring-blue-500"
        >
          Verify
        </button>
        <p v-if="verifyMessage" class="mt-4 text-center text-red-500 dark:text-red-400">{{ verifyMessage }}</p>
      </form>
    </div>
  </div>
</template>

<script>
    import { useAuthStore } from '@/stores/authStore';
  import authService from '@/services/authService';
  import { useRouter, useRoute } from 'vue-router';
  
  export default {
    name: 'Login2FA',
    data() {
      return {
        twoFactorCode: '',
        verifyMessage: ''
      };
    },
    setup() {
        const authStore = useAuthStore();
      const router = useRouter();
      const route = useRoute();
      return { authStore, router, route };
    },
    methods: {
        async verify2fa() {
            try {
                const response = await authService.verify2fa({
                email: this.route.query.email,
                twoFactorCode: this.twoFactorCode
                });
                this.authStore.login(response);

                this.verifyMessage = "Two-factor authentication successful";

                const role = this.route.query.role;
                if (role === 'ROLE_ADMIN') {
                this.router.replace({ name: 'DashboardPageAdmin' });
                } else if (['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'].includes(role)) {
                this.router.replace({ name: 'DashboardPageDispatcher' });
                } else {
                this.router.replace({ name: 'Dashboard' });
                }
            } catch (error) {
                this.verifyMessage = "Verification failed: " + (error.response?.data?.message || error.message);
                console.error("2FA verification error:", error);
            }
        }
    }
  };
  </script>
  
  <style scoped>
  .login-2fa {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  </style>
  